// NeedApplicationsSection — the applications list for one need, embedded inline
// on the employer need-detail page (no separate page; detail-from-detail was
// confusing). Reuses ApplicationCard + its status handlers.
import React, { useEffect, useState } from 'react';
import { FileText } from 'lucide-react';
import { jobApplicationApi } from '@/lib/api/jobApplicationApi';
import { JobApplication } from '@/lib/models/jobApplication';
import { ConfirmDialog } from '@/components/custom-ui/ConfirmDialog';
import ApplicationCard from './ApplicationCard';
import { useRehireConfirm } from './useRehireConfirm';

const NeedApplicationsSection: React.FC<{ needId: string }> = ({ needId }) => {
    const [applications, setApplications] = useState<JobApplication[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    const load = async () => {
        setIsLoading(true);
        try {
            const r = await jobApplicationApi.getApplicationsForNeed(needId, 1, 50);
            setApplications(r.applications);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => { void load(); }, [needId]);

    const { handleStatusUpdate, rehireDialog } = useRehireConfirm(load);

    return (
        <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-2 flex items-center gap-2">
                <FileText className="w-4 h-4 text-[#1A4D4F]" /> Ansökningar
                {applications.length > 0 && <span className="text-gray-400 font-normal">({applications.length})</span>}
            </h3>
            {isLoading ? (
                <p className="text-sm text-gray-400">Laddar ansökningar…</p>
            ) : applications.length > 0 ? (
                <div className="rounded-xl border border-gray-100 divide-y divide-gray-50">
                    {applications.map((app) => (
                        <ApplicationCard key={app.id} application={app} onStatusUpdate={handleStatusUpdate} />
                    ))}
                </div>
            ) : (
                <p className="text-sm text-gray-400">Inga ansökningar ännu.</p>
            )}
            <ConfirmDialog {...rehireDialog} />
        </div>
    );
};

export default NeedApplicationsSection;
